import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "table-responsive"
}
const _hoisted_2 = { class: "table align-middle gs-0 gy-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TableHeader = _resolveComponent("TableHeader")!
  const _component_TableRows = _resolveComponent("TableRows")!

  return (_ctx.mapping)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("table", _hoisted_2, [
          _createVNode(_component_TableHeader, {
            mapping: _ctx.mapping,
            "sort-by": _ctx.sortBy,
            "has-actions": _ctx.hasActions,
            onSort: _ctx.onSort
          }, null, 8, ["mapping", "sort-by", "has-actions", "onSort"]),
          _createVNode(_component_TableRows, {
            mapping: _ctx.mapping,
            items: _ctx.items,
            "route-key": _ctx.routeKey,
            "has-actions": _ctx.hasActions,
            onOpenModal: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('open-modal', $event))),
            onDelete: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('delete', $event))),
            onRowAction: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('row-action', $event))),
            onMoveUp: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('move-up', $event))),
            onMoveDown: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('move-down', $event)))
          }, null, 8, ["mapping", "items", "route-key", "has-actions"])
        ])
      ]))
    : _createCommentVNode("", true)
}